import React from "react";
import HotelSearchForm from "../Components/HotelsSearchForm"
function Hotels(){
    return(
        <>
        <section className="breadcrumb-main pt-15 bookingHeaderSection" >
            <div className="section-shape section-shape1 top-inherit bottom-0" ></div>
            <div className="breadcrumb-outer">
                <div className="container">
                    <div className="breadcrumb-content text-center">
                        <h1 className="mb-3">Hotels</h1>
                    </div>
                    <div className="row"> 
                        <HotelSearchForm />
                    </div>
                </div>
            </div>
        </section>
               
        </>
    )
}
export default Hotels;